<template>
  <div>
    <div>
      <Header />
    </div>

    <div class="main">
      <Contents />
    </div>

    <div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "../../components/private/Header";
import Contents from "./components/Contents.vue";
import Footer from "../../components/layout/Footer.vue";
export default {
  components: {
    Header,
    Contents,
    Footer,
  },
  mounted() {
    this.$store.commit("setPrivateView", "escritorio-virtual");
  },
};
</script>

<style scoped>
.main {
  background: #fff;
  margin-bottom: 30px;
}
</style>
